export const environment = {
    name: 'test',
    sentryDSN: 'https://b8b17b1858631bbcf26d746a9603059e@o4506856956493824.ingest.us.sentry.io/4507259823390720',
    traceUrls: ['dev.mit.mpo.dk', 'dev.my.musicnest.no']
};
